import React, { useEffect, useState } from 'react'
import { Border } from '../RecogntionAdmin/styles'
import { AdminCloseIcon, MonthlyCaloriesIcon } from '../../utils/icons'
import { StyledModal } from '../../containers/Education/styles'
import { CalendarHeader } from '../common/CommonModal/style'
import PropTypes from 'prop-types'
import { DisableEnableButton, GoalTableContainer, HeaderContainer, TypeContainer } from './styles'
// import { useHistory } from "react-router-dom";
import { commaSeperator, fetchApi } from '../../utils/methods'
import { toast } from 'react-toastify'
import { GetWellnessChallengeDayOptions } from '../../redux/constants/apiConstants'
import { ImageUrl } from '../../utils/constants'



function WellnessChallengePopup({show,onClose,wellnessChallengeData,onSelectStartPoint,  openPreQuiz/*,challengeId,refreshAnnouncements,setCurrentSlide */}) {
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [startPointData, setStartPointData] = useState(null);
  

  useEffect(() => {
    FetchStartingPointsData();
  }, []);


  const handleQuizPopup = () => {
    const selectedItem = startPointData?.find(
      (item) => item.level === selectedLevel
    );
  
    if (!selectedItem) return;
  
    // ✅ send full data to parent
    onSelectStartPoint(selectedItem);
  
    // existing flow
    openPreQuiz(wellnessChallengeData.id);
  };

  const FetchStartingPointsData = async()=>{
    try {
      const month_number = wellnessChallengeData?.month_number;
      const per_day_points = wellnessChallengeData?.per_day_points;
      const url = `${GetWellnessChallengeDayOptions}?month_number=${month_number}&per_day_points=${per_day_points}`;

      const res = await fetchApi(url, "GET");

      if(res.status === 'success'){
        setStartPointData(res.data)
       
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }



  // const SuccessToastEvent = (message) => {
  //   showSuccessToast(message);
  // } 


  // const joinChallenge = async () => {
  //   if (isJoining || selectedLevel === null) return; 
  //   setIsJoining(true);
  //   const payload = {
  //     monthly_gaol_challenge_id: challengeId,
  //     level_id: selectedLevel,
  //   };

  //   try {
  //     const res = await fetchApi(PostMonthlyGoalChallenge, "POST", payload);

  //     if (res.status === "success") {
  //       // SuccessToastEvent();
  //       SuccessToastEvent(res?.data?.message)
  //       // toast.success(res?.data?.message);
  //       refreshAnnouncements();
  //       setCurrentSlide(1);
  //       onClose();
  //       // history.push("/challenges/monthly-goal-challenge")

  //     } else {
  //       toast.error(res?.data?.message);
  //       setIsJoining(false);
  //     }
  //   } catch (error) {
  //     toast.error(error?.message || "Something went wrong");
  //     setIsJoining(false);
  //   } 
  // };


  
  const isDisabled = selectedLevel === null;


  return (
    <StyledModal show={show} width={'600px'} isPadding={"20px"}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <div>{"Choose Your Starting Point"}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <Border background={'#EFEFEF'} height={'0.75px'}/>
        <HeaderContainer>
          <TypeContainer>{MonthlyCaloriesIcon()}</TypeContainer>
          <div className='title'>How Many Days Would You Like To Do This Challenge! Please <br/> choose from the given options</div>
        </HeaderContainer>

        <GoalTableContainer>
          <div className="table-header">
            <span className="heading firstColumn">Level</span>
            <span className="heading">Days</span>
            <span className="heading lastColumn">Point Value</span>
          </div>
        
          {startPointData?.map((item) => (
            <div
              key={item.level}
              className={`table-row 
               ${selectedLevel === item.level ? "selected" : ""} 
             `}
              // className={`table-row ${selectedLevel === item.level ? "selected" : ""}`}
              onClick={() => setSelectedLevel(item.level)}
            >
              <div className="level">
              
                <img src={ImageUrl +"/"+ item?.icon} className="icon"></img>
                <span>{item?.title}</span>
              </div>
              <span>{commaSeperator(item?.days)} days</span>
              <span className="lastColumn">{commaSeperator(item?.point_value)}XP</span>
            </div>
          ))}
        </GoalTableContainer>

        <Border margin={"16px 0 16px 0"} background={'#EFEFEF'} height={'0.75px'}/>
        <DisableEnableButton
          width={"200px"}
          onClick={!isDisabled ? handleQuizPopup : null}
          isCursor={!isDisabled} 
          active={!isDisabled}
          disabledColor={isDisabled ? "#989898" : "#FEFEFE"}
          disabledBg={isDisabled ? "#EFEFEF" : "#DA6C74"}
          margin={"20px auto 0 auto"}>
          Next
        </DisableEnableButton>
      </div>

    </StyledModal>
  )
}

WellnessChallengePopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose:PropTypes.func,
  challengeId: PropTypes.number,
  refreshAnnouncements: PropTypes.func,
  setCurrentSlide: PropTypes.func,
  wellnessChallengeData: PropTypes.object,
  openPreQuiz: PropTypes.func,
  onSelectStartPoint: PropTypes.func,
};
  


export default WellnessChallengePopup
